// Utility per estrarre solo i PDB dopo "id"
const parsePdbIdsFromOutput = (output) => {
  if (!output || typeof output !== 'string') return [];

  const lower = output.toLowerCase();
  const idPos = lower.indexOf('id');
  if (idPos === -1) return [];

  // parte di stringa dopo "id"
  let afterId = output.slice(idPos + 2).trim();

  // sostituisci caratteri non alfanumerici con spazi e splitta
  afterId = afterId.replace(/[^0-9a-zA-Z\s]/g, ' ');
  const tokens = afterId.split(/\s+/);

  // tieni solo PDB a 4 caratteri alfanumerici
  const pdbs = tokens.filter((t) => /^[0-9A-Za-z]{4}$/.test(t));

  return pdbs.map((t) => t.toUpperCase());
};

export const processPdbId = async (apitoken, pdbId, setResults, setError) => {
  try {
    const response = await fetch('https://adapt-flask-ep.com/adapt/ws.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        serviceName: 'MATISSE',
        IDD: apitoken._id,
        Token: apitoken.tokens,
        pdbid: pdbId,
      }),
    });

    // Se HTTP non OK, errore
    if (!response.ok) {
      throw new Error(`HTTP_${response.status}`);
    }

    const responseData = await response.json();
    console.log(`Matisse process started for PDB ID: ${pdbId}`);
    console.log(responseData);

    // Estrai solo i PDB dopo "id"
    const onlyPdbs = parsePdbIdsFromOutput(responseData?.output);

    // Se vuoto, considera ITEM NOT FOUND
    if (!onlyPdbs || onlyPdbs.length === 0) {
      throw new Error('ITEM_NOT_FOUND');
    }

    // Accoda all'elenco globale
    setResults((prev) => [...prev, ...onlyPdbs]);
  } catch (error) {
    // Espone l'errore in alto (handleSearch) che gestirà alert + reload
    setError(`Error in the PDB ID ${pdbId} process: ${error.message}`);
    throw error;
  }
};

export const processFile = async (file, apitoken, setResults, setError) => {
  const fileText = await file.text();
  const pdbIds = fileText
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);

  for (const pdb of pdbIds) {
    await processPdbId(apitoken, pdb, setResults, setError);
  }
};
